"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const consumer_applications_v2_api_1 = require("consumer-applications-v2-api");
const hooks_1 = require("hooks");
const utils_1 = require("utils");
const useWaterfallEDS = () => {
    const [getBlackboxData] = (0, hooks_1.useIovation)();
    const [postApplyAfterPrequal, { data: dataApplyAfterPrequalResp, isLoading: isLoadingApplyAfterPrequal },] = (0, consumer_applications_v2_api_1.usePostConsumerApplicationsV2CreditApplicationsApplyAfterPrequalificationMutation)();
    const getApplyAfterPrequalArgs = (offer, applicationId) => {
        const acceptedOffer = offer;
        const { offerId: acceptedOfferId, terms: acceptedOfferTerms } = acceptedOffer ?? { offerId: 0, terms: [] };
        const blackboxData = getBlackboxData();
        const approvedTerms = acceptedOfferTerms
            ? (0, utils_1.approveTerms)(...acceptedOfferTerms)
            : [];
        const application = {
            applicationId,
            acceptedOfferId,
            iovationBlackBox: blackboxData.blackbox,
            prerequisiteTermsAccepted: approvedTerms,
        };
        return application;
    };
    return {
        dataApplyAfterPrequalResp,
        isLoadingApplyAfterPrequal,
        postApplyAfterPrequal,
        getApplyAfterPrequalArgs,
    };
};
exports.default = useWaterfallEDS;
